import { Injectable } from '@angular/core'
import { environment } from '../../../../environments/environment'
import { HttpClient, HttpParams } from '@angular/common/http'
import { Observable } from 'rxjs'
import { ResponseRequestModel } from '../../models/response.model'
import {
  DeleteProposalClientModel,
  SearchProposalClientModel,
} from '../../models/proposal-client.model'

@Injectable({
  providedIn: 'root',
})
export class PassengerService {
  private baseUrl = environment.baseUrl
  private resource = 'Passageiro'
  private importResource = 'ImportPassageiro'

  constructor(private httpClient: HttpClient) {}
  public excelImportPassenger(formData: FormData): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.importResource}/import/passageiro`,
      formData,
      {
        // O Content-Type será automaticamente definido como multipart/form-data
      },
    )
  }
  public createPassenger(
    model: any,
    // model: CreateProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/create`, model)
  }

  public editPassenger(
    model: any,
    // model: EditProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/edit`, model)
  }

  public deletePassenger(model: DeleteProposalClientModel): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/delete`, model)
  }
  public deletePassengerByLogistic(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/delete/${id}`, {})
  }

  public listPagedPassenger(page: number, rows = 15): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/listpaginated?pageNumber=${page}&pageSize=${rows}`,
    )
  }
  public getImportModel(): Observable<Blob> {
    return this.httpClient.get(`${this.baseUrl}${this.importResource}/download-modelo`, {
      responseType: 'blob',
    })
  }

  public deletePassengerBatch(ids: string[]): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete-lote`,
      ids,
    )
  }

  public deleteAllPassengersByContract(contratoId: number): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/delete-todos/${contratoId}`,
      {},
    )
  }

  public listAllImportHistory(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.importResource}/listall/import/passageiro`,
    )
  }

  public listPagedImportHistory(page: number, rows = 15): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.importResource}/listpaginated/import/passageiro?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public listPagedImportHistoryByContract(contratoId: any, page: number, rows = 15): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.importResource}/listpaginated/import/passageiro/contrato/${contratoId}?pageNumber=${page}&pageSize=${rows}`,
    )
  }

  public downloadImportLog(importPassageiroId: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.importResource}/import/passageiro/log/${importPassageiroId}`,
    )
  }

  public downloadImportExcel(importPassageiroId: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.importResource}/download/import/passageiro/excel/${importPassageiroId}`,
    )
  }

  public listPagedPassengerByContract(
    page: number,
    rows = 15,
    id: number,
    orderBy: string = '',
  ): Observable<ResponseRequestModel> {
    let params = new HttpParams().set('pageNumber', page).set('pageSize', rows)
    if (orderBy !== '') params = params.set('orderBy', orderBy)
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/contrato/${id}`,
      { params },
    )
  }

  public searchPagedPassengerByContract(
    page: number,
    rows = 15,
    id: number,
    model: any,
    orderBy: string = '',
  ): Observable<ResponseRequestModel> {
    let params = new HttpParams().set('pageNumber', page).set('pageSize', rows)

    Object.keys(model).forEach((key) => {
      const value = model[key]
      if (value !== null && value !== undefined && value !== '') {
        params = params.set(key, value)
      }
    })
    if (orderBy !== '' && orderBy !== null && orderBy !== undefined) {
      params = params.set('orderBy', orderBy)
    }
    return this.httpClient.get<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/contrato/${id}`,
      { params },
    )
  }

public searchPassenger(model: SearchProposalClientModel): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(`${this.baseUrl}${this.resource}/search`, model)
  }

  public searchPassengerByDocument(documento: string): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/documento/${documento}`)
  }

  public listPassenger(): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/listall`)
  }

  public getPassengerbyId(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/${id}`)
  }

  public searchPagedPassenger(
    page: number,
    rows = 15,
    model: SearchProposalClientModel,
  ): Observable<ResponseRequestModel> {
    return this.httpClient.post<ResponseRequestModel>(
      `${this.baseUrl}${this.resource}/search-paginated?pageNumber=${page}&pageSize=${rows}`,
      model,
    )
  }

  public downloadPassenger(id: number): Observable<ResponseRequestModel> {
    return this.httpClient.get<ResponseRequestModel>(`${this.baseUrl}${this.resource}/download-excel?id=${id}`)
  }
}
